<template>
  <div class="back-color-fff content-main-box" style="max-height:300px;height:100%">
    <!-- <el-table border stripe :max-height="300" :data="tableData" style="width: 840px;">
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="staffName" label="姓名" width="100"> </el-table-column>
      <el-table-column prop="mobileNo" label="手机号" width="120"> </el-table-column>
      <el-table-column prop="createTime" label="指派时间" type="daterange"> </el-table-column>
      <el-table-column prop="isMaintainStaff" label="是否负责人" width="90">
        <template slot-scope="scope">
          <span :style="scope.row.isMaintainStaff ? 'color:red' : ''">{{ scope.row.isMaintainStaff ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bizState" label="人员有效状态" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.bizState === 'Y' ? '有效' : '无效' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="140" v-if="!disabled">
        <template slot-scope="scope">
          <span class="twoAn" v-if="scope.row.isMaintainStaff === 1" @click="changeState(scope.row, 0)"
            style="cursor: pointer">{{ '取消负责人' }}</span>
          <span class="twoAn" v-else @click="changeState(scope.row, 1)" style="cursor: pointer">{{
            '设为负责人'
          }}</span>
          <span class="twoAn" @click="deletePeople(scope.$index)" style="cursor: pointer">删除</span>
        </template>
      </el-table-column>
    </el-table> -->

    <!-- 弹出框 -->
    <el-dialog title="选择人员" :visible.sync="showDialog" width="80%">
      <div class="select-box">
        <div class="box-left fl">
          <el-input v-model="filterText" class="mt15" placeholder="请输入部门/人员名称"></el-input>
          <el-tree v-if="isTreeShow" class="filter-tree mt10" :data="areaData"  node-key="guid"
            :filter-node-method="filterNodeDep" ref="treeDep" check-on-click-node  @node-click="handleNodeClick" >
            <!-- @check="checkChange" -->
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <img :src="data.icon" alt="" />
              <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
              <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
            </div>
          </el-tree>
        </div>
        <div class="box-right fr">
          <p class="fontC-bbb fl">已选{{ departmentList.length }}人</p>
          <el-button size="mini" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
          </el-button>
          <el-table :data="departmentList" border height="280px" style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column header-align="center" align="center" show-overflow-tooltip prop="label" label="名称">
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addAButton">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { removeDuplicates } from '@/uilt/tool';
export default {
  props: {
    showChoosePerson: {
      type: Boolean,
      default: false,
    },
    areaData: { // 人员组织列表
      type: Array,
      default: [],
    },
    list: { // 人员组织列表
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      isTreeShow: true,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRows: 0,
      },
      showDialog: false,
      filterText: '',
      tableData: [],
      delList: [], // 删除项
      departmentList: [], // 勾选项
      uniqueArr: [], // 去重后的选项
      limitSwitch:true // 人数限制开关
    };
  },
  watch: {
    showDialog(val) {
      this.$emit('update:showChoosePerson', val);
     
    },
    showChoosePerson(val) {
      this.showDialog = val;
      
    },
    list: {
      deep: true,
      immediate: true,
      
      handler(val) {
        this.tableData = JSON.parse(JSON.stringify(val))
      }
    },
    tableData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.limitSwitch) {
          // this.$emit('getPerson', this.tableData)
        }
      }
    },
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  computed: {
    disabled() {
      return this.$route.query.disabled ? true : false
    },
    haveMaintainStaff() {
      return this.tableData.find(item=>item.isMaintainStaff)
    }
  },
  methods: {
    //切换状态
    changeState(item, state) {
      let tipContent = this.haveMaintainStaff ? `是否将负责人由【${this.haveMaintainStaff.staffName}-${this.haveMaintainStaff.mobileNo}】变更为【${item.staffName}-${item.mobileNo}】` : `是否将【${item.staffName}-${item.mobileNo}】设为负责人`
      let tip = state ? tipContent : '是否取消负责人'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData.forEach(item => {
          item.isMaintainStaff = 0
        })
        item.isMaintainStaff = state;
        this.tableData = [...this.tableData];
      }).catch(() => {

      });
    },
    deletePeople(index) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData.splice(index, 1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data){
      console.log('data',data);
      let departmentList = removeDuplicates(
        [data].filter((item) => item.nodeType !== '1'),
        ['id', 'staffName', 'mobileNo'],
      );
      console.log('departmentList',departmentList);
      
      this.departmentList = departmentList
      
    },
    checkChange(val,list) {
      console.log('nn',val,list);
      
      if (list.checkedKeys.length >= 1) {
        //单选实现
        console.log('单选实现',[val.guid]);
        this.$refs.treeDep.setCheckedKeys([],true);
        this.$refs.treeDep.setCheckedKeys([val.guid],true);
        
        this.$nextTick(()=>{})
        this.$forceUpdate()
        console.log('///',this.$refs.treeDep.getCheckedKeys());
        
        
        
     }
    //  console.log('**',this.$refs.treeDep.getCheckedKeys());
     
      
      let departmentList = removeDuplicates(
        this.getCheckedNodes().filter((item) => item.nodeType !== '1'),
        ['id', 'staffName', 'mobileNo'],
      );
      // let resTable = removeDuplicates([...this.tableData, ...departmentList], ['staffName', 'mobileNo'])
      // if (resTable.length > 10) {
      //   this.limitSwitch = false
      //   this.$NewMessage.warning({message: '您已超限, 最多指派10人'})
      // } else {
      //   this.departmentList = departmentList
      // }
      console.log('departmentList',departmentList);
      
      this.departmentList = departmentList
    },
    getCheckedNodes() {
      
      return this.$refs.treeDep.getCheckedNodes().filter((item) => !item.children);
    },
    //删除
    delDepartment() {
      if (this.delList == null || this.delList.length == 0) {
        this.$message.error('请勾选数据！');
        return;
      }
      this.departmentList = this.departmentList.filter(item => !this.delList.some(delItem => item.id === delItem.id))
      this.isTreeShow = false;
      this.$nextTick(()=>{
        // 重新渲染菜单树节点
        this.isTreeShow = true;
        this.$nextTick(()=>{
          this.departmentList.forEach(item=>{
            debugger
            this.$refs.treeDep && this.$refs.treeDep.setChecked(item.guid,true,false)
          })
        })
      })
     
    },
    handleSelectionChange(val) {
      this.delList = val;
    },
    addAButton() {
      // 历史数据和勾选数据合并然后去重
      let resTable = removeDuplicates([...this.tableData, ...this.departmentList], ['staffName', 'mobileNo'])
      // if (resTable.length > 10) {
      //   this.limitSwitch = false
      //   this.$NewMessage.warning({message: '您已超限, 最多指派10人'})
      // } else {
      //   this.limitSwitch = true
      //   this.tableData =  resTable
      // }
      console.log('888',this.departmentList);
      
      this.tableData =  resTable
      if(this.departmentList.length==1){
        this.$emit('getPerson', this.departmentList[0])
        this.showDialog = false
      }else{
        this.$message.error('请勾选数据！');
      }
      
      // console.log('this.tableData',this.tableData);
      
      
      
    }
  },
};
</script>

<style lang="less" scoped>
.select-box {
  // display: flex;
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.twoAn {
  color: #4fa1a4;
  font-size: 14px;
  margin-right: 10px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
